import { useCallback, useEffect, useState } from 'react';

import { DEFAULT_PIXEL_SDK_READY_EVENT, isDefaultPixelSdkConfigured } from '~/constants/defaultPixel';

const getInitialDefaultPixelSdkReady = (): boolean => {
  if (!isDefaultPixelSdkConfigured()) {
    return true;
  }

  if (window.DefaultPixelSDK?.submitForm) {
    return true;
  }

  const status = window.__defaultPixelSdkStatus__;

  return status === 'loaded' || status === 'failed';
};

export const useDefaultPixelSdkReady = () => {
  const [isReady, setIsReady] = useState(getInitialDefaultPixelSdkReady);

  const markReady = useCallback(() => {
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (!isDefaultPixelSdkConfigured()) {
      return;
    }

    if (window.DefaultPixelSDK?.submitForm || window.__defaultPixelSdkStatus__) {
      markReady();
      return;
    }

    window.addEventListener(DEFAULT_PIXEL_SDK_READY_EVENT, markReady);
    return () => {
      window.removeEventListener(DEFAULT_PIXEL_SDK_READY_EVENT, markReady);
    };
  }, [markReady]);

  return { isDefaultPixelSdkReady: isReady };
};
